module.exports = __webpack_public_path__ + "img/0001.f47b4c05.jpg";